<template>
  <article
    ref="page"
    class="dte-sheet dte-sheet--banner-full"
    :class="sheetClass"
  >
    <div class="dte-full-page-banner">
      <img
        :src="documentData.issuer.bannerUrl"
        alt="Banner emisor"
        class="dte-full-page-banner__image"
      />
    </div>

    <div class="dte-sheet__page-number">
      {{ pageLabel }}
    </div>
  </article>
</template>

<script>
export default {
  name: "DteFullPageBannerSheet",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: "full",
    },
    pageNumber: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    sheetClass() {
      return `dte-sheet--${this.layout}`;
    },
    pageLabel() {
      if (this.layout === "standard") {
        return `Pagina ${this.pageNumber} de ${this.totalPages}`;
      }

      return `Pag. ${this.pageNumber} / ${this.totalPages}`;
    },
  },
  methods: {
    getPageElement() {
      return this.$refs.page || null;
    },
  },
};
</script>
